import React, { useEffect } from "react";
import "./App.css";
import { Provider } from "react-redux";
import configureStore from "./config/rootStore";
import CheckToken from "./utils/CheckToken";
import { withDevCycleProvider } from "@devcycle/react-client-sdk";
import { RootRoute } from "./routes/RootRoute";
import Notification from "./components/notification/Notification";
import { StorageHelper } from "./utils/StorageHelper";
import packageJson from "../package.json";
function App() {
  const { store } = configureStore();
  useEffect(() => {
    const caching = () => {
      const version = StorageHelper.instance.GetVersion();
      if (version !== packageJson.version) {
        StorageHelper.instance.SaveVersion(packageJson.version);
        console.log("versions");
        if ("caches" in window) {
          caches
            .keys()
            .then((names) => {
              if (names.length)
                names.forEach((name) => {
                  caches.delete(name);
                  console.log("versions " + name);
                });
              else console.log("no cached names");
            })
            .catch((err) => console.error("Cache keys error:", err));

          // Makes sure the page reloads. Changes are only visible after you refresh.
          // window.location.reload(true);
          window.location.href =
            window.location.href.split("?")[0] + "?_=" + version;
        }
      }
    };
    caching();
  }, []);
  useEffect(() => {
    window.process = {
      ...window.process,
    };
  }, []);

  return (
    <Provider store={store}>
      <CheckToken>
        <RootRoute />
        {/* <div>hello world</div> */}
      </CheckToken>
      <Notification />
    </Provider>
  );
}

export default withDevCycleProvider({
  envKey: process.env.REACT_APP_FLAG_KEY,
  user: { user_id: "USER_ID", isAnonymous: true },
})(App);
